import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import BrandLogo from "../components/BrandLogo";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [status, setStatus] = useState("loading");
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!token) {
      setStatus("error");
      setMessage("Missing verification token.");
      return;
    }

    api
      .get("/auth/verify-email", { params: { token } })
      .then((r) => {
        setStatus("success");
        setMessage(r.data.message || "Email verified successfully.");
      })
      .catch((err) => {
        setStatus("error");
        setMessage(err?.response?.data?.detail || "Verification failed.");
      });
  }, [token]);

  return (
    <div className="min-h-screen grain-bg p-6 md:p-10 flex items-center justify-center">
      <div className="max-w-md w-full card-soft p-8 md:p-10 text-center">
        <BrandLogo to="/" size="lg" className="mx-auto mb-6" testid="verify-email-logo" />
        <h1 className="font-display font-bold text-2xl">Email verification</h1>
        {status === "loading" && (
          <p className="mt-4 text-sm" style={{ color: "var(--text-muted)" }}>Verifying your email…</p>
        )}
        {status === "success" && (
          <>
            <p className="mt-4 text-sm" style={{ color: "var(--text-muted)" }}>{message}</p>
            <Link
              to="/login"
              className="inline-block mt-6 h-11 px-6 leading-[2.75rem] rounded-md text-white font-semibold tactile-btn"
              style={{ background: "var(--primary)" }}
              data-testid="verify-email-login-link"
            >
              Sign in
            </Link>
          </>
        )}
        {status === "error" && (
          <>
            <p className="mt-4 text-sm" style={{ color: "var(--destructive, #b91c1c)" }}>{message}</p>
            <Link
              to="/login"
              className="inline-block mt-6 text-sm font-semibold"
              style={{ color: "var(--primary)" }}
              data-testid="verify-email-back-link"
            >
              Back to sign in
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
